import { isPlatformBrowser } from '@angular/common';
import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { ReautenticacionService } from './reautenticacion.service';

/**
 * Pone el token en cada petición y, si el servidor lo rechaza por vencido,
 * pide la contraseña encima de la pantalla y reenvía la petición.
 *
 * Reenviar es seguro aun para un guardado: el 401 lo da el guard antes de que
 * el controlador procese nada.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const reauth = inject(ReautenticacionService);
  const esNavegador = isPlatformBrowser(inject(PLATFORM_ID));

  return next(conToken(req, auth.getToken())).pipe(
    catchError((error: unknown) => {
      const sesionVencida =
        error instanceof HttpErrorResponse && error.status === 401 && !esLogin(req);
      if (!sesionVencida) return throwError(() => error);

      // En el servidor (SSR) no hay pantalla ni sesión que renovar.
      if (!esNavegador) return throwError(() => error);

      return reauth.renovar().pipe(
        switchMap((ok) => (ok ? next(conToken(req, auth.getToken())) : throwError(() => error))),
      );
    }),
  );
};

function conToken(req: HttpRequest<unknown>, token: string | null) {
  return token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;
}

/** El login responde 401 ante credenciales malas; ahí no hay sesión que renovar. */
function esLogin(req: HttpRequest<unknown>): boolean {
  return req.url.includes('/auth/login');
}
